<script>
export default {
  props: {
    color: {
      type: String,
      default: "#000",
    },
  },
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linecap: round;
      stroke-linejoin: round;
    "
    viewBox="0 0 108 113"
    :fill="color"
    aria-label="Home-Symbol"
  >
    <path
      d="M7.726 17.017v-2.453c0-.624.509-1.131 1.139-1.135h2.309c.633 0 1.147.508 1.147 1.135v2.461c0 .53.427.963.962.975h1.539c1.535 0 2.778-1.231 2.778-2.751V8.27c-.008-.597-.291-1.159-.769-1.524l-5.264-4.198c-.923-.731-2.234-.731-3.156 0L3.17 6.754c-.48.364-.764.926-.77 1.524v6.971C2.4 16.769 3.644 18 5.179 18h1.539c.548 0 .993-.44.993-.983"
      :style="`fill: none; fill-rule: nonzero; stroke: ${color}; stroke-width: 1.3px`"
      transform="matrix(6.49622 0 0 6.49622 -11.368348 -8.769957)"
    />
  </svg>
</template>
